import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import platform from "Pub/js/platform";
import { langCheck } from "Pub/js/utils";
const { NCDropdown } = platform.base;
const { pageTo, base } = platform;
const { NCTooltip } = base;
import CollectTooltip from 'Components/CollectTooltip';
import { QuickAddIcon } from "Components/QuickLaunchIcon";
import { getStore, setStore } from '../../../pub/js/storageUtils';

//图标维护
let icons = {
    bd_apply: 'icon-quanbuyingyong',
    bd_material: 'icon-icon-material',
    bd_supplier: 'icon-icon-supplier',
    bd_psndoc: 'icon-icon-personnel',
    bd_project: 'icon-icon-project',
    bd_customer: "icon-icon-customer",
    bd_account: "icon-icon-Account",
    pam_equip: "icon-a-icon-AssetCard",
    fa_card: "icon-a-icon-FixedAssetsCard",
};

class ResultPanel extends Component {
    /**
     * props： data： 父組件传来的渲染数据
     */
    constructor(props) {
        super(props);
        this.autoFlag = this.getAutoFlag();
        this.state = { cursor: 'auto', // 控制鼠标箭头
        };
    }

    //自动化环境 开关
    getAutoFlag = () => getStore('_ncc_automated_') == '1';

    componentDidMount() {
        //监听箭头事件
        let { refInput } = this.props;
        refInput.addEventListener('keydown', this.handleKeyDown);
        findDOMNode(this).addEventListener('mousemove', this.handleMouseMove);
    }
    componentWillUnmount() {
        let { refInput } = this.props;
        refInput.removeEventListener('keydown', this.handleKeyDown);
        findDOMNode(this).removeEventListener('mousemove', this.handleMouseMove);
    }

    handleKeyDown = e => {
        let { curFocus, data, onFocusChange } = this.props;
        let { menuData, basicData } = data;
        let rows = (basicData[basicData.length - 1] || {}).rows || [];
        let basicLength = (rows[rows.length - 1] || {}).index || 0;
        menuData = menuData.length > 50 ? menuData.slice(0, 50) : menuData;
        let menuDataLength = menuData.length ? menuData.length + 1 : menuData.length; //1是指标题
        let maxLength = menuDataLength + basicLength;
        let getTitleArray = () => {
            let arr = [{ curFocus: 0 }, { curFocus: 1 }]; //0是"搜索更多结果"
            basicData.forEach((item, index) => {
                arr.push({ curFocus: item.titleIndex + menuData.length + 1, typeIndex: index });
            });
            return arr;
        };
        //检查当前焦点是否是标题
        let checkTitle = curFocus => {
            let result = { isTitle: false, typeIndex: -1 };
            let titleArray = getTitleArray();
            titleArray.forEach((item, index) => {
                if (item.curFocus == curFocus) {
                    result.isTitle = true;
                    result.typeIndex = item.typeIndex;
                }
            });
            return result;
        };
        //Enter 键
        if (e.keyCode === 13) {
            let { isTitle, typeIndex } = checkTitle(curFocus);
            if (isTitle) {
                let type;
                if (curFocus == 0) {
                    //type 保持undefined
                } else if (curFocus == 1) {
                    type = 'bd_apply';
                } else {
                    type = basicData[typeIndex].type;
                }
                this.handleClick(type);
            } else if (0 < curFocus && curFocus <= menuData.length + 1) {
                this.onOpenNewTab(e, menuData[curFocus - 2]); //-2的原因是"当前记录上存在‘搜更多结果’和‘标题’"
            } else {
                let index = curFocus - menuData.length - 1;
                let displayName, appPageInfo, id;
                let isLink = true;
                basicData.forEach((item, i) => {
                    item.rows.forEach((row, j) => {
                        if (row.index == index) {
                            if (row.appPageInfos.length > 1) {
                                findDOMNode(this).querySelector(`.pop-panel${curFocus}`).click();
                                isLink = false;
                                return;
                            }
                            id = row.id;
                            displayName = basicData[i].rows[j].values.name.value;
                            appPageInfo = basicData[i].rows[j].appPageInfos[0];
                            return;
                        }
                    });
                });
                if (isLink) {
                    this.handleItemClick(displayName, appPageInfo, id, "bd_apply");
                }
            }
        }
        // 上箭头
        if (e.keyCode === 38 && curFocus > 0) {
            e.preventDefault();
            onFocusChange(curFocus - 1);
            this.setState({ cursor: 'none' });
            setTimeout(() => {
                ReactDOM.findDOMNode(this).querySelector('.active-background').scrollIntoView({ block: 'nearest' });
            }, 0);
        }

        //下箭头
        if (e.keyCode === 40 && curFocus < maxLength) {
            console.log(curFocus, maxLength);
            e.preventDefault();
            this.setState({ cursor: 'none' });
            onFocusChange(curFocus + 1);
            setTimeout(() => {
                ReactDOM.findDOMNode(this).querySelector('.active-background').scrollIntoView({ block: 'nearest' });
            }, 0);
        }

    }

    handleMouseMove = () => {
        if (this.state.cursor === "none") {
            this.setState({ cursor: 'auto' });
        }
    }
    render() {
        let { cursor } = this.state;
        let { data, keyword, load, updateCollect, curFocus, onFocusChange, type } = this.props;
        let { menuData, basicData, iniBasicData } = data;
        let { key } = type;
        let menuDataLength = JSON.parse(JSON.stringify(menuData)).length;
        menuData = menuData.length > 50 ? menuData.slice(0, 50) : menuData;
        let { menuLoad, basicLoad } = load;
        let noData = !menuLoad && !basicLoad && !menuData.length && !basicData.length;
        // 封装骨架屏
        let renderSkeleton = () => {
            return <div className='skeleton-wrapper'>
                <div className='skeleton-title'>
                    <h3 className="skeleton-title-left"></h3>
                    <h3 className="skeleton-title-right"></h3>
                </div>
                <div className='skeleton-item'>
                    <h3 className="skeleton-item-first"></h3>
                    <h3 className="skeleton-item-second"></h3>
                    <h3 className="skeleton-item-second"></h3>
                    <h3 className="skeleton-item-second"></h3>
                    <h3 className="skeleton-item-third"></h3>
                </div>
            </div>;
        };

        return <div
            className="search-result"
            onMouseDown={e => e.preventDefault()}
        >
            <div
                className={`search-more-wrapper ${curFocus === 0 ? "active-background" : ""}`}
                onMouseEnter={() => onFocusChange(0)}
                onMouseMove={() => { if (curFocus !== 0) { () => onFocusChange(0); } }}
            >
                <div
                    className="search-more "
                    style={{ pointerEvents: cursor }}
                    onClick={() => this.handleClick()}
                >  
                    <span className='search-text'>
                        {langCheck("0000PUB-000541") /* 国际化处理： 搜索*/}
                    </span>
                    <span
                        className="keyword"
                        style={{ pointerEvents: cursor }}
                    >

                        "{keyword}"
                    </span>
                    <span className='more-result'>
                        {langCheck("0000PUB-000542") /* 国际化处理： 相关的更多结果*/}
                    </span>
                    <i className='icon iconfont icon-jiantouyou arrow-icon' />
                </div>
            </div>
            <hr className='hr' />

            {
                noData ?
                    <div className="empty-data-result">
                        <i className='icon iconfont icon-sousuo1 icon-empty'></i>
                        <span >{langCheck("0000PUB-000543") /* 国际化处理： 暂无搜索结果*/}</span>
                    </div>
                    :
                    <div className='result-content fieldid_global-search_select' >
                        {(key == "bd_apply" || key == "all") &&
                            menuLoad ?
                            // 骨架屏区域
                            renderSkeleton()
                            :
                            <div>
                                {/* 应用菜单标题区域 */}
                                {key == "bd_apply" && !menuData.length
                                    ?
                                    <div className="empty-data-result">
                                        <i className='icon iconfont icon-sousuo1 icon-empty'></i>
                                        <span >{langCheck("0000PUB-000543") /* 国际化处理： 暂无搜索结果*/}</span>
                                    </div>
                                    :
                                    !menuData.length && basicLoad && (key === "bd_apply" || key === "all") ?
                                        renderSkeleton()
                                        :
                                        menuData.length > 0 && <div
                                            className={`result-title ${curFocus === 1 ? "active-background" : ""}`}
                                            onMouseEnter={() => onFocusChange(1)}
                                            onMouseMove={() => { if (curFocus !== 1) { () => onFocusChange(1); } }}
                                            style={{ pointerEvents: cursor }}
                                            onClick={() => this.handleClick("bd_apply")}
                                        >
                                            <i className={` icon iconfont ${icons.bd_apply} left-icon icon-title`} />
                                            <span
                                                className='title-text'
                                            >
                                                {langCheck("0000PUB-000544") /* 国际化处理：应用*/}
                                            </span>
                                            <span>({menuDataLength})</span>
                                            <i className='icon iconfont icon-jiantouyou arrow-icon' />
                                        </div>
                                }
                                {/* 应用菜单标题对应行信息 */}
                                {menuData.slice(0, 50).map((menu, i) => {
                                    let { appid, label } = menu;

                                    return <NCTooltip
                                        overlay={this.isRenderTip(`.menu-text-width${i}`, 150) ? label : ""}
                                        placement="right"
                                    >
                                        <div
                                            key={appid}
                                            className={`menu-item ${curFocus === i + 2 ? "active-background" : ""}`}
                                            style={{ pointerEvents: cursor }}
                                            onMouseEnter={() => { onFocusChange(i + 2); }}
                                            onMouseMove={() => { if (curFocus !== i + 2) { () => onFocusChange(i + 2); } }}
                                            onClick={e => this.onOpenNewTab(e, menu)}
                                        >

                                            <a
                                                className='item-text menu-item-left'
                                                style={{ pointerEvents: cursor }}
                                            >
                                                {
                                                    this.autoFlag ?
                                                        <span
                                                            className={`menu-text-width${i}`}
                                                            style={{ pointerEvents: cursor }}
                                                        >
                                                            {label}
                                                        </span>
                                                        :
                                                        <span
                                                            className={`menu-text-width${i}`}
                                                            style={{ pointerEvents: cursor }}
                                                            dangerouslySetInnerHTML={{ __html: this.highlight(label, keyword, "span") }}>
                                                        </span>
                                                }

                                            </a>
                                            <div className="menu-item-right">
                                                <QuickAddIcon visible={!!menu.fastlaunchparam} appData={menu} />
                                                <NCTooltip
                                                    className="app-tooltip"
                                                    placement='top'
                                                    overlay={langCheck('0000PUB-000372')}
                                                    trigger='hover'
                                                    delayShow={500}
                                                    delay={1}
                                                    mouseLeaveDelay={0}
                                                >
                                                    <i
                                                        className="iconfont icon-xinyeqiandakai app-open"
                                                        item-index={i}
                                                        onClick={e => { this.onOpenNewTab(e, menu, true); }}
                                                    />
                                                </NCTooltip>
                                                <CollectTooltip
                                                    key={menu.appcode}
                                                    itemData={{
                                                        appcode: menu.appcode,
                                                        menuitemid: menu.value,
                                                        menuitemcode: menu.code,
                                                        is_collect: menu.is_collect,
                                                        is_cloud_app: menu.is_cloud_app,
                                                    }}
                                                    contentData={menuData}
                                                    setNewContentData={data => updateCollect(data)}
                                                />
                                            </div>
                                        </div>
                                    </NCTooltip>;
                                })
                                }
                            </div>
                        }

                        {(key !== "bd_apply" && key !== "all" && !basicData.length && !basicLoad)
                            ?
                            <div className="empty-data">
                                <i className='icon iconfont icon-sousuo1 icon-empty'></i>
                                <span >{langCheck("0000PUB-000543") /* 国际化处理： 暂无搜索结果*/}</span>
                            </div>
                            :
                            basicLoad ?
                                // 骨架屏区域
                                renderSkeleton()
                                :
                                !basicData.length && menuLoad && key !== "bd_apply"
                                    ?
                                    renderSkeleton()
                                    :
                                    <div>
                                        {/* 其他档案,和下拉框顺序保持一致 */}
                                        {
                                            basicData.map((item, itemIndex) => {
                                                console.log('iniBasicData', basicData, iniBasicData);
                                                let { displayName = "", rows = [], pageInfo } = iniBasicData[item.type] || {};
                                                let focusIndex = menuData.length ? item.titleIndex + menuData.length + 1 : item.titleIndex;
                                                return rows.length > 0 &&
                                                    <div key={item.type}>
                                                        {/* 标题区域 */}
                                                        <div
                                                            className={`result-title ${curFocus === focusIndex ? "active-background" : ""}`}
                                                            onMouseEnter={() => onFocusChange(focusIndex)}
                                                            onMouseMove={() => { if (curFocus !== focusIndex) { () => onFocusChange(focusIndex); } }}
                                                            style={{ pointerEvents: cursor }}
                                                            onClick={() => this.handleClick(item.type)}
                                                        >
                                                            <i
                                                                className={`icon iconfont ${icons[item.type]} icon-title `}
                                                            />

                                                            <span
                                                                className='title-text'
                                                            >
                                                                {displayName}
                                                            </span>
                                                            <span>({pageInfo.total})</span>
                                                            <i className='icon iconfont icon-jiantouyou arrow-icon' />
                                                        </div>
                                                        {/* 标题对应行信息*/}
                                                        <div>
                                                            {rows.map((row, i) => {
                                                                let { id, values, index, appPageInfos = [] } = row;
                                                                let code = values.code.value;
                                                                let name = values.name.value;
                                                                let focusIndex = menuData.length ? menuData.length + 1 + index : index;
                                                                return <div
                                                                    className='result-item'
                                                                    key={id}
                                                                >
                                                                    {
                                                                        (appPageInfos || []).length > 1 ?
                                                                            // 弹出面板
                                                                            <NCDropdown
                                                                                trigger={['click']}
                                                                                overlay={<div className="extra-panel">
                                                                                    {appPageInfos.map(appPageInfo => {
                                                                                        let { displayName } = appPageInfo;
                                                                                        return <a
                                                                                            className='extra-panel-item'
                                                                                            key={displayName}
                                                                                            onClick={() => this.handleItemClick(displayName, appPageInfo, id, item.type)}
                                                                                        >
                                                                                            <span dangerouslySetInnerHTML={{ __html: this.highlight(displayName, keyword, "span") }}></span>
                                                                                        </a>;
                                                                                    })
                                                                                    }
                                                                                </div>}
                                                                                animation="slide-up"
                                                                                overlayClassName='item-drop'
                                                                            >
                                                                                <div
                                                                                    className={` ${curFocus === focusIndex ? "active-background" : "item-text-wrapper"}`}
                                                                                    style={{ pointerEvents: cursor }}
                                                                                    onMouseEnter={() => onFocusChange(focusIndex)}
                                                                                    onMouseMove={() => { if (curFocus !== focusIndex) { () => onFocusChange(focusIndex); } }}
                                                                                >
                                                                                    <a
                                                                                        style={{ pointerEvents: cursor }}
                                                                                        className={`item-text pop-panel${focusIndex}`}
                                                                                    >
                                                                                        {
                                                                                            this.autoFlag ?
                                                                                                <span>
                                                                                                    <span >{name}</span>
                                                                                                    <span>{(code)}</span>
                                                                                                </span>
                                                                                                :
                                                                                                <span>
                                                                                                    <span dangerouslySetInnerHTML={{ __html: this.highlight(name, keyword, "span") }}></span>
                                                                                                    (<span dangerouslySetInnerHTML={{ __html: this.highlight(code, keyword, "span") }}></span>)
                                                                                                </span>
                                                                                        }

                                                                                    </a>
                                                                                </div>
                                                                            </NCDropdown>
                                                                            :
                                                                            <NCTooltip
                                                                                overlay={this.isRenderTip(`.basic-text-width${index}`, 228) ? `${name}(${code})` : ""}
                                                                                placement="right"
                                                                            >
                                                                                <div
                                                                                    className={` ${curFocus === focusIndex ? "active-background" : "item-text-wrapper"}`}
                                                                                    style={{ pointerEvents: cursor }}
                                                                                    onClick={() => this.handleItemClick(name, appPageInfos[0], id, item.type)}
                                                                                    onMouseEnter={() => onFocusChange(focusIndex)}
                                                                                    onMouseMove={() => { if (curFocus !== focusIndex) { () => onFocusChange(focusIndex); } }}
                                                                                >
                                                                                    <a
                                                                                        style={{ pointerEvents: cursor }}
                                                                                        className='item-text'
                                                                                    >
                                                                                        {
                                                                                            this.autoFlag ?
                                                                                                <span
                                                                                                    className={`basic-text-width${index}`}
                                                                                                    style={{ pointerEvents: cursor }}
                                                                                                >
                                                                                                    {name}{`(${code})`}
                                                                                                </span>
                                                                                                :
                                                                                                <span
                                                                                                    className={`basic-text-width${index}`}
                                                                                                    style={{ pointerEvents: cursor }}
                                                                                                    dangerouslySetInnerHTML={{ __html: this.highlight(`${name}(${code})`, keyword, "span") }}
                                                                                                >
                                                                                                </span>
                                                                                        }

                                                                                    </a>
                                                                                </div>
                                                                            </NCTooltip>
                                                                    }
                                                                </div>;
                                                            })}
                                                        </div>
                                                    </div>;
                                            })
                                        }
                                    </div>
                        }
                    </div>
            }

        </div >;
    }

    //选中大类/搜更多跳转至全局搜索中心
    handleClick = (titleKey = "noTitleKey") => {
        console.log(titleKey);
        // 拼接关键词和分类，跳转到全局搜索中心
        let { keyword = "noKeyword", type } = this.props;
        this.props.onHidden();
        //配合全局搜索中心
        setStore('refresh_page', false);
        setTimeout(() => {
            pageTo.openTo("../../../../uapwb/gsc/center/list/index.html", {
                appcode: "00221301",
                pagecode: "00221301GSC_list",
                status: 'browse',
                titleKey,
                keyword:encodeURIComponent(encodeURIComponent(keyword)),
                selectKey: type.key,
                searchCenterPage: true, //全局搜索中心页面标志位
                tabName: langCheck("0000PUB-000545"), /* 国际化处理： 全局搜索中心*/
            });
        }, 150);
        // /nccloud/resources/Uapss//*  */gsc/center/list/index.html#/?appcode=00221301&pagecode=00221301GSC_list
    }
    //应用菜单打开新页签
    onOpenNewTab = (e, menu, newTab = false) => {
        let { label, appcode } = menu;
        e.stopPropagation();
        this.props.onHidden();
        if (menu.code) {
            menu.menuitemcode = menu.code; //传菜单编码
        }
        setTimeout(() => {
            window.openNew(menu, null, null, { openTabWithoutCheck: newTab });
        }, 150);
        const { menuitemcode, labelMap } = menu;
        this.pushToRecent({ display: label, appcode, iconType: "bd_apply", menuitemcode, labelMap });
    }
    // 其他档案打开新页签
    handleItemClick = (displayName, appPageInfo, id, iconType) => {
        let { appcode, pagecode } = appPageInfo || {};
        this.pushToRecent({ display: displayName, appcode, iconType, id, pagecode });
        this.props.onHidden();
        // 打开节点
        setTimeout(() => {
            pageTo.openTo(null, {
                appcode,
                pagecode,
                status: 'browse',
                id,
            });
        }, 150);
    }

    // 添加到最近浏览
    pushToRecent = ({ display, appcode, iconType, id, pagecode, menuitemcode, labelMap }) => {
        const userId = getStore("STOREFORINFODATA", true).userId;
        const global_search = "global_search";
        let { viewed = [], history = [] } = ((getStore(global_search) || {})[userId]) || {};
        //浏览记录存在此信息，则将此信息置顶
        for (let i = 0; i < viewed.length; i++) {
            if (viewed[i].display === display) {
                viewed.unshift(...viewed.splice(i, 1));
                setStore(global_search, {
                    [userId]: {
                        history: [],
                        viewed: viewed,
                    },
                });
                return; //退出
            }
        }
        //不存在此信息则进行添加操作 
        let data = {
            history: history,
            viewed: [
                { id, display, appcode, icon: icons[iconType], pagecode, menuitemcode, labelMap },
                ...viewed,
            ],
        };
        //最大浏览记录条数限制
        const maxLength = 5;
        if (viewed.length >= maxLength) {
            data.viewed = data.viewed.slice(0, maxLength);
        }
        //覆盖原数据
        setStore(global_search, { [userId]: data });
    }

    /**
    * 关键字高亮
    * @params content 内容
    * @params keyword 关键词
    * @params tagName 标签名
   */
    highlight = (content = "", keyword, tagName) => {
        let regKeyWord = new RegExp(keyword, 'gi');
        const lightKeyword = (content.match(regKeyWord)||'').toString() ;
        const newText = `<${tagName} style="color:red;">${lightKeyword}</${tagName}>`;
        return content.replace(new RegExp(lightKeyword, 'g'), newText);
    }
    /**
       * 文本超过最大宽度显示气泡
       * @params target  目标元素
       * @params maxWidth 最大宽度
      */
    isRenderTip = (target, maxWidth) => {
        let domWidth = (findDOMNode(this).querySelector(target) || {}).offsetWidth || 0;
        if (domWidth >= maxWidth) {
            return true;
        } else {
            return false;
        }
    }

}

export default ResultPanel;